import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";

// const pagestyle =(page)=>{
// if (page ===21 || page ===41||page ===21 || page ===61||page ===81 || page ===101||page ===121 || page ===141|| page ===161|| page ===181){
//   return { display:'block', float:'left' };
// }
// }
const Pagination = ({ itemsCount, pageSize, currentPage, onPageChange }) => {
  const pagesCount = Math.ceil(itemsCount / pageSize);
  if (pagesCount === 1) return null;
  const pages = _.range(1, pagesCount + 1);
  

  return (
 
    <nav style={{ direction: "rtl"   }} >
       
      <ul className="pagination  flex-wrap" >
      {
         
      }
        {pages.map(page => (
 
          <li
            key={page}  
            className={page === currentPage   ? "page-item active  " : "page-item "   }  
          >
            <a className="page-link" onClick={() => onPageChange(page)}>
              {page}
            </a>
          </li>
        ))}
      </ul>
      </nav>
 
  );
};

Pagination.propTypes = {
  itemsCount: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,

};

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/common/pagination.jsx